import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import ManageCategories from './ManageCategories'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function FullScreenDialog({ handleChange, categories, label, deleteCat }) {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      {isMobile ? (
        <Box component={'span'} onClick={handleClickOpen}>
          {label}
        </Box>
      ) : (
        <Button
          sx={{
            marginLeft: '5px',
            color: 'white',
            '&:hover': { color: 'black', backgroundColor: 'white' },
          }}
          onClick={handleClickOpen}
        >
          {label}
        </Button>
      )}
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        sx={{ '.MuiDialog-paper': { backgroundColor: theme.palette.appBar.main } }}
      >
        <AppBar
          sx={{
            position: 'relative',
            backgroundColor: theme.palette.appBar.top,
          }}
        >
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {t('finance.categorisation.manageCategoriesTitle')}
            </Typography>
          </Toolbar>
        </AppBar>
        <Box
          style={{
            backgroundColor: theme.palette.appBar.main,
            // minHeight: "200vh",
          }}
        >
          <Container>
            <ManageCategories
              handleChange={handleChange}
              deleteCat={deleteCat}
              categories={categories}
            />
          </Container>
        </Box>
      </Dialog>
    </div>
  )
}
